module.exports = __webpack_public_path__ + "202408221624/img/pao.c1d4ab4b.png";